<section class="login-page">
    <div class="errorpage">
        <div class="loader-bg">
            <div class="loader-track">
                <div class="loader-fill"></div>
            </div>
        </div>
        <!-- p-b-10  -->
        <div class="header sticky bg-primary shadow">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <div class="desktoplogo">
                            <img routerLink="/" class="logo shadow" src="assets/images/brand/logo2.png" alt="Logo">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="auth-main errorpage">
            <div class="row gx-0"> 
                <div class="col-lg-7 d-none  d-lg-block"> 
                    <img routerlink="/" src="assets/images/login_page_xeneta_2.jpg" class=" img-fluid">
                </div> 
                <div class="col-lg-5 bg-dark">
                    <div class="auth-wrapper v2 p-4">
                        <div class="auth-form">
                            <div class="card bg-dark shadow-sm">
                                <div class="card-body align-content-center">
                                    <div [formGroup]="loginForm" class="w-100">
                                        <div class="d-flex justify-content-between my-4">
                                            <h1 class="text-light fw-bolder" style="align-content: space-around; ">XBL</h1>
                                            <img routerlink="/" src="assets/images/lynkit_logo.png" alt="Logo" class="logo shadow mb-2">
                                        </div>
                                        <!-- <div class="text-center my-4">
                                            <img routerlink="/" src="assets/images/lynkit_logo.png"
                                                class="logo shadow mb-2" alt="Logo">
                                        </div> -->
                                        <!-- <h3 class="text-start text-light fw-bolder mb-4">XBL Lynkit</h3> -->
                                        <div class="form-group mb-3">
                                            <label class="form-label text-light" for="floatingInput">E-mail</label>
                                            <input type="email" formControlName="email" class="form-control"
                                                id="floatingInput" placeholder="Enter Your Email">
                                        </div>

                                        <div class="form-group mb-3">
                                            <label class="form-label text-light" for="floatingInput1">Password</label>
                                            <input [type]="isPasswordVisible ? 'text' : 'password'"
                                                formControlName="password" class="form-control" id="floatingInput1"
                                                placeholder="Enter Your Password">
                                        </div>

                                        <div class="d-flex justify-content-between align-items-center">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox" id="checkbox-1"
                                                    (change)="togglePasswordVisibility()">
                                                <label class="form-check-label text-primary" for="checkbox-1"
                                                    style="font-size: x-small;">Show Password</label>
                                            </div>
                                            <small class="text-muted text-grey cursor-pointer" data-bs-toggle="modal" hidden
                                                data-bs-target="#forgetModal">
                                                <i class="ti ti-lock-off"></i> Forgot Password?
                                            </small>
                                        </div>

                                        <div class="d-grid mt-4">
                                            <button type="submit" class="btn btn-primary fw-bolder"
                                                [disabled]="!loginForm.valid" (click)="login()">Login</button>
                                        </div>

                                        <div class="d-flex justify-content-center align-items-center my-4">
                                            <hr class="flex-grow-1 border-secondary" hidden>
                                            <span class="mx-3 text-secondary" hidden>Or</span>
                                            <hr class="flex-grow-1 border-secondary" hidden>
                                        </div>

                                        <h6 class="text-center text-secondary" hidden>
                                            New Users? <a href="#" class="text-primary">Signup</a>
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Forgot Password Modal -->
        <div class="modal fade" id="forgetModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="text-center">
                            <h2>Forgot Your Password?</h2>
                            <p class="text-muted">Input your registered email to reset your password</p>
                        </div>
                        <form>
                            <div class="form-group mb-3">
                                <label for="emailInput" class="form-label">Email</label>
                                <input type="email" [formControl]="emailControl" id="emailInput" class="form-control"
                                    placeholder="Enter Registered Email" required>
                                <div *ngIf="emailControl.invalid && (emailControl.dirty || emailControl.touched)">
                                    <small *ngIf="emailControl.hasError('required')">You must enter an email.</small>
                                    <small *ngIf="emailControl.hasError('pattern')">Not a valid email.</small>
                                </div>
                            </div>
                            <div class="d-flex justify-content-between">
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button type="button" class="btn btn-primary" [disabled]="!emailControl.valid"
                                    (click)="forgetPassword()">Reset Password</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>